import { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import CustomInput from "../CustomInput";
import { Button } from "react-bootstrap";
import { useForgotPassword } from "../../../hooks/authV2/useForgotPassword";

export const AuthForgotPassword = ({ setView }) => {
  const [email, setEmail] = useState("");
  const { loading, error, forgotPassword } = useForgotPassword();

  const initialValues = { email: "" };

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const handleSubmit = async (values) => {
    await forgotPassword({
      email: values.email,
      onSuccess: () => {
        setEmail(values.email);
      },
    });
  };

  return (
    <>
      {email ? (
        /* ---------- Success State ---------- */
        <>
          <div className="auth-modal-title">Check your email.</div>

          <p className="auth-forgot__subtitle">
            we sent a password reset link to
          </p>
          <p className="auth-forgot__email">{email}</p>

          <p className="auth-forgot__resend">
            Didn't receive the email?{" "}
            <span className="authLink" onClick={() => setEmail("")}>
              Resend
            </span>
          </p>
        </>
      ) : (
        /* ---------- Email Form State ---------- */
        <>
          <div className="auth-modal-title">Forgot Password?</div>
          <p className="auth-forgot__subtitle">
            We'll send you reset instructions.
          </p>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="auth-form-group">
                  <CustomInput
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    showAstreisk={true}
                  />
                </div>

                {error && (
                  <div className="text-danger text-center mb-3">{error}</div>
                )}

                <Button
                  type="submit"
                  className="custom-primary-button mt-2"
                  disabled={loading || isSubmitting}
                >
                  {loading ? "Sending..." : "Reset Password"}
                </Button>
              </Form>
            )}
          </Formik>
        </>
      )}

      {/* ---------- Back to Login ---------- */}
      <div
        className="auth-forgot__backBtn"
        onClick={() => setView("login")}
      >
        <i className="bi bi-arrow-left"></i> Back to Login
      </div>
    </>
  );
};
